<a *ngIf="currentRoute !== ''; else elseBlock" rel="home" routerLink="/">
  <img [src]="logoSrc" [alt]="nonHomePageAltText">
</a>
<ng-template #elseBlock><img [src]="logoSrc" [alt]="homePageAltText"></ng-template>